import React from 'react';
import { Trophy, MapPin, Navigation, Shirt } from 'lucide-react';
import { KickoffCountdown } from './KickoffCountdown';

export const PLAYOFF_ANNOUNCEMENT_ID = 'announcement-2026-11-01-week8-game-day';
const PLAYOFF_DATE = '2026-11-01';
const FIRST_KICKOFF = '10:30';
const CAWLEY = 'Cawley Stadium, 424 Douglas Road, Lowell, MA 01852';
const DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(CAWLEY)}`;
const SLATE = [
  ['9U', 'Medford', '10:30 AM', '8:30 AM'],
  ['11U', 'Lowell Red Raiders', '12:00 PM', '10:00 AM'],
  ['13U', 'Roxbury Titans', '1:30 PM', '11:30 AM'],
];

export const PlayoffHypeCard = ({ id = 'popup' }) => (
  <div className="mt-4 bg-[#0a1f44] text-white border-t-4 border-[#f4b400] p-4 sm:p-5" data-testid={`playoff-hype-${id}`}>
    <div className="flex items-center gap-2 font-heading uppercase tracking-[0.3em] text-[10px] text-[#f4b400]"><Trophy className="w-4 h-4" aria-hidden="true" /> Playoffs · Round 1 · Sunday, Nov 1</div>
    <div className="font-display text-2xl leading-tight mt-1">We're the home team — <span className="text-[#f4b400]">wear navy!</span></div>
    <div className="mt-3"><KickoffCountdown id={`playoff-${id}`} date={PLAYOFF_DATE} time={FIRST_KICKOFF} compact /></div>
    <ul className="mt-3 grid gap-1.5 text-sm" data-testid={`playoff-hype-slate-${id}`}>
      {SLATE.map(([div, opp, game, arrive]) => (
        <li key={div} className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-0.5 sm:gap-3 border-b border-white/10 pb-1.5">
          <span><span className="font-display text-[#c8102e] text-lg mr-2">{div}</span>vs {opp}</span>
          <span className="text-xs text-white/70 whitespace-nowrap sm:text-right">Game {game} · Arrive {arrive}</span>
        </li>
      ))}
    </ul>
    <div className="mt-3 flex items-start gap-2 text-xs text-white/75"><MapPin className="w-4 h-4 text-[#c8102e] shrink-0" aria-hidden="true" /><span>{CAWLEY}</span></div>
    <div className="mt-3 flex flex-col sm:flex-row gap-2">
      <a href={DIRECTIONS} target="_blank" rel="noopener noreferrer" className="min-h-11 inline-flex items-center justify-center gap-2 bg-[#c8102e] hover:bg-[#e11d34] text-white font-heading uppercase tracking-widest text-[10px] px-4 transition-colors" data-testid={`playoff-hype-directions-${id}`}><Navigation className="w-3.5 h-3.5" aria-hidden="true" /> Directions to Cawley</a>
      <div className="min-h-11 inline-flex items-center justify-center gap-2 border border-[#f4b400]/60 text-[#f4b400] font-heading uppercase tracking-widest text-[10px] px-4" data-testid={`playoff-hype-wear-navy-${id}`}><Shirt className="w-3.5 h-3.5" aria-hidden="true" /> Home team · Wear navy</div>
    </div>
  </div>
);
